import { useState } from "react";
import { instance } from "../../../../utils/utils";

const rol = {
  10: "Super Usuario",
  20: "Operario",
  30: "Profesional de la salud",
};

const EditUserRol = ({ onClose, user }) => {
  const [loader, setLoader] = useState(false);
const [error, setError] = useState(null);
const editUserRol = async (e) => {
  e.preventDefault();
  setLoader(true);
  try {
    let formData = new FormData(e.target);
    formData.append("first_name", formData.get("first_name"));
    formData.append("last_name", formData.get("last_name"));
    formData.append("role", formData.get("role"));
    formData.append("email", formData.get("email"));
    formData.append("password", formData.get("password"));

    await instance.patch(`users/roles/${user.id}/`, formData);
    onClose();
  } catch (err) {
    console.error(err);
    let errorMessage = "Ocurrió un error al editar el usuario";
    if (err.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (err.response.status === 400) {
        // Handle validation errors
        const errors = err.response.data;
        errorMessage = Object.values(errors).flat().join(" ");
      } else if (err.response.status === 401) {
        errorMessage = "No tienes permiso para realizar esta acción";
      } else if (err.response.status >= 500) {
        errorMessage = "Error en el servidor. Por favor, intente más tarde";
      }
    } else if (err.request) {
      // The request was made but no response was received
      errorMessage =
        "No se pudo conectar al servidor. Verifica tu conexión a internet";
    }

    setError(errorMessage);
    setTimeout(() => {
      setError(null);
    }, 3000);
  } finally {
    setLoader(false);
  }
};

return (
  <div>
    <div className="mb-4">
      <span style={{ textAlign: "center" }}>
        {loader ? (
          <span style={{ textAlign: "center" }}>Actualizando...</span>
        ) : (
          <span style={{ textAlign: "center" }}>Editar rol de usuario</span>
        )}
      </span>
      {error && (
        <div
          className="alert alert-danger mt-2 py-1"
          style={{ fontSize: "0.8rem" }}
        >
          {error}
        </div>
      )}
    </div>
    <form onSubmit={editUserRol} className="d-flex flex-column gap-2">
      <div className="d-flex px-4">
        <input
          required
          defaultValue={user.first_name}
          placeholder="Nombre"
          name="first_name"
          type="text"
          className="searchAtletas py-2 mx-auto"
          style={{
            border: "1px solid var(--elevvaTextSubtitle)",
            borderRadius: "20px",
            fontSize: "calc(.4rem + .4vw)",
            width: "100%",
          }}
        />
      </div>
      <div className="d-flex px-4">
        <input
          required
          defaultValue={user.last_name}
          placeholder="Apellido"
          name="last_name"
          type="text"
          className="searchAtletas py-2 mx-auto"
          style={{
            border: "1px solid var(--elevvaTextSubtitle)",
            borderRadius: "20px",
            fontSize: "calc(.4rem + .4vw)",
            width: "100%",
          }}
        />
      </div>
      <div className="d-flex px-4">
        <input
          required
          defaultValue={user.email}
          placeholder="Correo Electrónico"
          name="email"
          type="email"
          className="searchAtletas py-2 mx-auto"
          style={{
            border: "1px solid var(--elevvaTextSubtitle)",
            borderRadius: "20px",
            fontSize: "calc(.4rem + .4vw)",
            width: "100%",
          }}
        />
      </div>
      <div className="d-flex px-4">
        <input
          required
          defaultValue={user.password}
          placeholder="Contraseña"
          name="password"
          type="password"
          className="searchAtletas py-2 mx-auto"
          style={{
            border: "1px solid var(--elevvaTextSubtitle)",
            borderRadius: "20px",
            fontSize: "calc(.4rem + .4vw)",
            width: "100%",
          }}
        />
      </div>
      <div className="d-flex px-4">
        <select
          required
          name="role"
          defaultValue={user.role}
          className="searchAtletas py-2 mx-auto"
          style={{
            border: "1px solid var(--elevvaTextSubtitle)",
            borderRadius: "20px",
            fontSize: "calc(.4rem + .4vw)",
            width: "100%",
          }}
        >
          {Object.entries(rol).map(([key, value]) => (
            <option key={key} value={key}>
              {value}
            </option>
          ))}
        </select>
      </div>
      <div className="d-flex justify-content-center mt-3">
        <button
          type="submit"
          style={{
            fontSize: "calc(.4rem + .32vw)",
          }}
          className="d-flex add_location px-4 py-1"
        >
          Confirmar
        </button>
      </div>
    </form>
  </div>
);
};

export default EditUserRol;
